@if (notice$ | async; as notice) {
  <div class="decision-backdrop" (click)="closeFromBackdrop(notice)">
    <section class="decision-notice" [attr.role]="isMobilePresentation ? 'region' : 'dialog'"
      [attr.aria-modal]="isMobilePresentation ? null : 'true'" [attr.aria-live]="isMobilePresentation ? 'polite' : null"
      [attr.aria-labelledby]="notice.id + '-title'" cdkTrapFocus [cdkTrapFocus]="!isMobilePresentation"
      [cdkTrapFocusAutoCapture]="!isMobilePresentation" (click)="$event.stopPropagation()">
      <div class="decision-notice__content">
        <span class="decision-notice__icon"><mat-icon>{{notice.icon || 'priority_high'}}</mat-icon></span>
        <div class="decision-notice__copy">
          @if (isMobilePresentation) { <small>Aviso</small> }
          <h2 [id]="notice.id + '-title'">{{notice.title}}</h2>
          <p>{{notice.message}}</p>
        </div>
        @if (isMobilePresentation && notice.dismissible) {
          <button type="button" class="decision-notice__close" aria-label="Cerrar aviso" (click)="close()"><mat-icon>close</mat-icon></button>
        }
      </div>
      <footer>
        @for (action of notice.actions; track action) {
          <button type="button" [ngClass]="'decision-notice__action--' + action.appearance" (click)="run(action)">{{action.label}}</button>
        }
      </footer>
    </section>
  </div>
}
